<template>
  <v-app>
    <v-main>
      <sds-layout :loading="loading" class="fill-height">
        <router-view />
      </sds-layout>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import LoadingModule from '@/store/modules/LoadingModule';

@Component({
  name: 'app'
})
export default class App extends Vue {
  public get loading(): boolean {
    return LoadingModule.loading;
  }
}
</script>
